import React from 'react';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    card: {
        float: 'left',
        margin: '-7px 0 0 0',
        zIndex: 100,
        borderRadius: 3,
    },
    icon: {
        float: 'right',
        width: 20,
        height: 20,
        padding: 4,
        color: '#fff',
    },
});

const CardIcon = ({ Icon, bgColor, cursor }) => {
    const classes = useStyles();
    return (
        <Card className={classes.card} style={{ backgroundColor: bgColor , cursor: cursor}}>
            <Icon className={classes.icon} />
        </Card>
    );
};

export default CardIcon;